import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
    en: {
        card: "Card",
        valid: "Card valid date",
        last_used: "Card last used date",
        phCard: "Enter a part of your card",
        burn: "Burnable accumulation on end of month",
        tt: {
            debit: "Card bilance",
            amt_disc: "Total amount of deals",
            discount: "Current discount"
        },
        errors: {
            block: "Card is blocked!",
            not_found: "Card not found",
            digits: "Only digits allowed in card",
            length: "Wrong length of card",
            "400": "Anything was wrong try again later!",
            "404": "Card not found!",
        }
    },
    lv: {
        card: "Karte",
        valid: "Kartes derīguma termiņš",
        last_used: "Pēdējā izmantošana",
        phCard: "Ievadiet kartes numuru",
        burn: "Mēneša beigās dzēšamie atlikumi",
        tt: {
            debit: "Kartes atlikums",
            amt_disc: "Pirkumu summa",
            discount: "Jūsu uzkrājuma procents"
        },
        errors: {
            block: "Card is blocked!",
            not_found: "Karte nav atrasta",
            length: "Nepareizs simbolu skaits kartes numurā",
            digits: "Kartes numurā atļauts izmantot tikai ciparu",
            "400": "Nezināmā kļūda, meģinājiet velāk!",
            "404": "Karte nav atrasta"
        }
    },
    ru: {
        card: "Карта",
        debit: "Остаток на карте",
        valid: "Карта действительна до",
        last_used: "Дата последнего использования",
        phCard: "Введите номер карты",
        current_discount: "Скидка",
        amount_discount: "Общий оборот",
        burn: "Сжигаемые накопления в конце месяца",
        tt: {
            debit: "Остаток на карте",
            amt_disc: "Общий оборот",
            discount: "Скидка"
        },
        errors: {
            block: "Карта блокирована!",
            not_found: "Карта не найдена",
            length: "Неправильное количество символов в номере карты",
            digits: "В номере используются только цифры",
            "400": "Неизвестная ошибка, попробуйте еще раз позже!",
            "404": "Карта не найдена"
        }
    }
}

const i18n = new VueI18n({ locale: "ru", messages })
export default i18n;  